module.exports = __webpack_public_path__ + "img/ug.a7021a7d.svg";